exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icrs-footer-bottom-section[data-v-10a15e00]{padding-bottom:2rem}.icrs-footer-bottom-section .icrs-footer-bottom-section-copyright[data-v-10a15e00]{text-align:right;padding-right:4rem;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.footer-links a[data-v-10a15e00]:focus-visible{outline:2px solid grey}@media (max-width:992px){.icrs-footer-bottom-section .icrs-footer-bottom-section-copyright[data-v-10a15e00]{margin-top:1rem;text-align:left;padding-right:0}}", ""]);

// exports
